/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ANCHOR from 'common/consts/anchor';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import ds, { media } from 'designsystem';
import { Column, Row } from 'hedron';
import { Newsletter as NewsletterModel } from 'models';
import MailingService from 'services/Mailing.service';
import CustomForm from 'blocks/Form/CustomForm';
import CustomFormElement from 'blocks/Form/CustomFormElement';
import SubmitButton from 'blocks/Form/SubmitButton';
import Header2 from 'elements/Header2';
import Paragraph from 'elements/Paragraph';
import CustomCheckbox from 'blocks/Form/CustomCheckbox';
import { Bind } from 'lodash-decorators';
import FORM from 'common/consts/form';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import { removeTags, safeHtmlWithBr } from 'common/methods/string';

const CheckboxContainer = styled.div`
  transition: all 0.35s ease-out;
  transform-origin: 50% 75%;
  position: relative;

  ${({ visible }) =>
    visible
      ? 'transform: scaleY(1); margin-top: 0; opacity: 1;'
      : `transform: scaleY(0.33); margin-top: -${ds.get('metrics.xxl')}; opacity: 0;`}
`;

const StyledCustomForm = styled(CustomForm)`
  position: relative;
  justify-content: flex-end;
  ${media.desktop`
    margin-top:${ds.get('metrics.l')};
`};
`;

const StyledRow = styled(Row)`
  margin: ${({ margin }) => (margin ? `0 ${ds.get('metrics.s')}` : '')};
  margin-top: ${ds.get('metrics.xl')};
`;

@inject('windowStore', 'coreStore', 'appStore')
@observer
@withRouter
export default class Newsletter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        email: '',
        dataProcessingCheckbox: false,
        dataSendingCheckbox: false,
      },
      resetValue: false,
      buttonState: '',
      isRodoVisible: false,
    };
  }

  @Bind()
  updateInputValue(input) {
    const { inputName, value } = input;

    const { formData } = this.state;
    formData[inputName] = value;

    this.setState(formData);
  }

  @Bind()
  async submitForm(event) {
    event.preventDefault();
    const {
      formData: { email },
    } = this.state;
    const {
      appStore: {
        currentLanguage,
      },
      history,
    } = this.props;

    this.setState({
      buttonState: FORM.BUTTON_STATE.LOADING,
    });

    let resultCode;
    try {
      await MailingService.sendNewsletter({ email });
      resultCode = 200;

      this.setState({
        buttonState: FORM.BUTTON_STATE.SUCCESS,
      });

      setTimeout(() => {
        this.resetState();
      }, FORM.SUCCESS_MESSAGE_TIMEOUT);

      this.setState({
        resetValue: false,
      });
    } catch (e) {
      this.setState({
        buttonState: FORM.BUTTON_STATE.ERROR,
      });
      try {
        const errData = await e.json();
        resultCode = errData.code;
      } catch (err) {
        resultCode = e.status;
      }
    } finally {
      history.push({
        pathname: `${ANCHOR.THANK_YOU[currentLanguage]}`,
        state: { code: resultCode },
      });
    }
  }

  @Bind
  showRodoCheckboxes() {
    this.setState({
      isRodoVisible: true,
    });
  }

  resetState() {
    this.setState({
      formData: {
        email: '',
        dataProcessingCheckbox: false,
        dataSendingCheckbox: false,
      },
      buttonState: '',
      resetValue: true,
    });
  }

  render() {
    const {
      content: { description, title, label, htmlModifiers },
      windowStore,
      coreStore: { translations },
      margin,
    } = this.props;

    const { resetValue, buttonState, isRodoVisible } = this.state;

    return (
      <HTMLModifiableBackground
        htmlModifiers={htmlModifiers}
        color={ds.brand('white')}
        overflow="visible"
      >
        <StyledRow margin={margin ? 1 : 0} divisions={11}>
          <Column fluid={!windowStore.isOnTablet} lg={5}>
            <Header2
              dangerouslySetInnerHTML={{
                __html: safeHtmlWithBr(title),
              }}
            />
            <Paragraph
              dangerouslySetInnerHTML={{
                __html: safeHtmlWithBr(description),
              }}
            />
          </Column>
          <Column fluid={!windowStore.isOnTablet} lg={5} lgShift={1}>
            <StyledCustomForm onSubmit={this.submitForm}>
              <CustomFormElement
                type="email"
                name="email"
                required
                labelName={label}
                validateOnInput
                getValue={this.updateInputValue}
                onInput={this.showRodoCheckboxes}
                resetValue={resetValue}
              />

              <CheckboxContainer visible={isRodoVisible}>
                <CustomCheckbox
                  marginTop={ds.get('metrics.s')}
                  type="checkbox"
                  name="dataProcessingCheckbox"
                  checkboxText={
                    translations.FORM_CHECKBOX_DATA_PROCESSING_LABEL
                  }
                  required
                  resetValue={resetValue}
                  getValue={this.updateInputValue}
                />
                {removeTags(translations.FORM_CHECKBOX_DATA_SENDING_LABEL) && (
                  <CustomCheckbox
                    marginTop={ds.get('metrics.s')}
                    type="checkbox"
                    name="dataSendingCheckbox"
                    checkboxText={translations.FORM_CHECKBOX_DATA_SENDING_LABEL}
                    required
                    resetValue={resetValue}
                    getValue={this.updateInputValue}
                  />
                )}
              </CheckboxContainer>

              {!windowStore.isOnTablet && <Column lg={3} lgShift={1} />}

              <SubmitButton
                centered={windowStore.isOnTablet}
                buttonState={buttonState}
              />
            </StyledCustomForm>
          </Column>
        </StyledRow>
      </HTMLModifiableBackground>
    );
  }
}

Newsletter.propTypes = {
  content: PropTypes.instanceOf(NewsletterModel).isRequired,
  margin: PropTypes.bool,
};

Newsletter.defaultProps = {
  margin: true,
};



// WEBPACK FOOTER //
// ./src/kentico-blocks/Newsletter/index.jsx